import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { TrialBalanceViewRow } from "./trialBalanceViewTypes";
import styles from "./TrialBalanceTable.module.scss";

export const TrialBalanceTitleCell: React.FC<
    CellContext<ViewTableFeatures, TrialBalanceViewRow, unknown>
> = React.memo(({ row }) => (
    <ViewTableCell
        className={row.original.isSummary ? styles.summaryCell : undefined}
    >
        {row.original.title}
    </ViewTableCell>
));

TrialBalanceTitleCell.displayName = "TrialBalanceTitleCell";
